// extracted by mini-css-extract-plugin
export default {"card":"card__-68b3aa9c","row":"row__-68b3aa9c","group":"group__-68b3aa9c","label":"label__-68b3aa9c","fixed":"fixed__-68b3aa9c","value":"value__-68b3aa9c"};